<template>
  <span class="mx-1 small text-sm" v-if="modelValue">
    {{ prepend }}
    {{ text }}
  </span>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    modelValue: {
      type: [String],
      required: false,
      default: null
    },
    format: {
      type: [String],
      required: false,
      default: 'M/D/YY'
    },
    prepend: {
      type: [String],
      required: false,
    }
  },
  computed: {
    text() {
      return this.modelValue ? moment(this.modelValue).format(this.format) : null
    }
  }
}
</script>
